// Central, single source of truth for site-wide contact info and nav links.
// Update here once — Header, Footer, Contact page, and CTAs all read from this.

export const SITE = {
  name: 'EightyThreeLabs',
  url: 'https://eightythreelabs.com',
  tagline: 'AI automation and Microsoft Copilot consulting. Built to run, not to demo.',
  description:
    'EightyThreeLabs - AI automation and Microsoft Copilot consulting. Workflow automation, AI agents, and Power Platform for SMEs and enterprises. Based in Toronto.',
  contact: {
    name: 'Yahya D.',
    role: 'Senior Consultant & Developer',
    email: 'yahya@eightythreelabs.com',
  },
  location: {
    city: 'Toronto',
    region: 'ON',
    country: 'Canada',
    serving: 'Serving clients across North America',
  },
  calendly: 'https://calendly.com/eightythreelabs/15min',
  linkedin: 'https://www.linkedin.com/company/eightythreelabs/',
  responseTime: 'one business day',
  founded: 2024,
  /** Official Microsoft certification titles — keep in sync with Credly. */
  certifications: [
    { code: 'AI-102', name: 'Azure AI Engineer Associate', area: 'Azure AI' },
    { code: 'PL-900', name: 'Power Platform Fundamentals', area: 'Power Platform' },
    { code: 'DP-900', name: 'Azure Data Fundamentals', area: 'Azure Data' },
    { code: 'MB-920', name: 'Dynamics 365 Fundamentals (ERP)', area: 'Dynamics 365' },
    { code: 'AZ-900', name: 'Azure Fundamentals', area: 'Azure' },
  ],
} as const;

export type Certification = (typeof SITE.certifications)[number];

export interface NavLink {
  label: string;
  to: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'FAQ', to: '/faq' },
];

// Footer "Pages" column. Microsoft 365 Setup lives under the footer's
// "Services" column (and as a service card), not here.
export const FOOTER_PAGES: NavLink[] = [
  { label: 'Home', to: '/' },
  ...NAV_LINKS,
  { label: 'Contact', to: '/contact' },
];
